import { reducer as formReducer } from 'redux-form';
import skeletonState from '../../store/partialState/skeletonState';

const boolConverter = (val) => (
  typeof val === 'boolean' ? val :
  typeof val === 'string' && val.toLowerCase() === 'true' ? true : false
)

//todo: тут-бы прибраться
const form = formReducer.plugin({

  detail: (state = skeletonState, action) => {

    switch (action.type) {

      case '@@redux-form/CHANGE': {
        const printProductNumberPayload = boolConverter(action.payload);

        if (action.meta.field === 'printProductNumber' && printProductNumberPayload) {
          const { 
            sleeve, 
            embroideryText, 
            embroideryFont, 
            embroideryColor, 
            embroidery 
          } = state.values;
          return {
            ...state,
            values: {
              ...state.values,
              printProductNumber: printProductNumberPayload,
              embroideryText: embroideryText ? embroideryText : '',
              embroideryFont: embroideryFont ? embroideryFont :'Arial',
              embroideryColor: embroideryColor ? embroideryColor : '1000M',
              embroidery: !embroidery && (sleeve === 'sleeveShort' || sleeve === 'sleeveShortCuff') ?
                'embroideryAtFront' : embroidery ? embroidery : 'embroideryAtCuff',
            }
          }
        }

        if (action.meta.field === 'printProductNumber' && !printProductNumberPayload) {

          const {
            embroideryText,
            embroideryFont,
            embroideryColor,
            embroidery,
            ...withoutEmbroidery
          } = state.values;

          return {
            ...state,
            values: { ...withoutEmbroidery, printProductNumber: printProductNumberPayload },
          }
        }

        if (!Boolean(action.payload) || action.payload === 'false') {

          const {
            [action.meta.field]: value,
            ...withoutDeleted
          } = state.values;

          return {
            ...state,
            values: withoutDeleted,
          }
        };

        if (action.meta.field === 'sleeveType' && action.payload == 'sleeveLong') {
          return {
            ...state,
            values: {
              ...state.values,
              sleeve: action.payload,
            },
          }
        };

        if (action.meta.field === 'sleeveType' && action.payload == 'sleeveShort') {
          const { cuff, cuffStyle, cuffDensity } = skeletonState;
          return {
            ...state,
            values: {
              ...state.values,
              cuff,
              cuffStyle,
              cuffDensity,
            },
          }
        };

      }
      default: {
        return { ...state };
      }

    }

  }
})

export default form;